export default "__VITE_ASSET__6cc9f946__"